import './Footer.css';

import { withRouter } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

const Footer = props => {
  const [version] = useState('2.3.21.240321_release');
  useEffect(() => {
    checkVersion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkVersion = () => {
    const oldVersion = localStorage.getItem('version');

    //版本升级后清除原有的浏览器缓存
    if (version !== oldVersion) {
      props.clearUserInfo();
      props.clearCurrentInfo();
      localStorage.setItem('version', version);
    }
  };

  const { isLoginFooter } = props;
  return (
    <div className={isLoginFooter ? 'footer login-footer' : 'footer'}>
      <p>
        Copyright © 2021九峰医疗{' '}
        <a href="https://beian.miit.gov.cn/#/Integrated/index">
          赣ICP备15007797号-2
        </a>
        <br />
        版本号：{version}
      </p>
    </div>
  );
};
Footer.propTypes = {
  isLoginFooter: PropTypes.bool,
  clearUserInfo: PropTypes.func,
  clearCurrentInfo: PropTypes.func,
};
export default withRouter(Footer);
